import { render, staticRenderFns } from "./OnamaeTableContainer.vue?vue&type=template&id=1d037084&"
import script from "./OnamaeTableContainer.vue?vue&type=script&lang=js&"
export * from "./OnamaeTableContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports